import { useNavigate, useSearch } from '@tanstack/react-router';

const useSimpleSort = (opts = {}) => {
    const { inverseFields = [], defaultSortField } = opts;

    const navigate = useNavigate();
    const { ordering = defaultSortField } = useSearch({});

    const sortField = ordering?.replace(/^-/, '');
    const isDescending = ordering?.startsWith('-') || false;

    const sortOrder = (() => {
        if (!sortField) return 'asc';
        if (inverseFields.includes(sortField)) {
            return isDescending ? 'asc' : 'desc';
        }
        return isDescending ? 'desc' : 'asc';
    })();

    const getOrderingParam = (field, direction) => {
        const isInverse = inverseFields.includes(field);
        if (isInverse) {
            return direction === 'asc' ? `-${field}` : field;
        }
        return direction === 'desc' ? `-${field}` : field;
    };

    const setSortField = field => {
        if (!field) return;

        const newOrder =
            field === sortField
                ? getOrderingParam(field, sortOrder === 'asc' ? 'desc' : 'asc')
                : getOrderingParam(field, 'asc');

        navigate({ search: { ordering: newOrder } });
    };

    const toggleDirection = () => {
        if (!sortField) return;

        const newOrder = getOrderingParam(
            sortField,
            sortOrder === 'asc' ? 'desc' : 'asc',
        );

        navigate({ search: { ordering: newOrder } });
    };

    return {
        sortField,
        sortOrder,
        setSortField,
        toggleDirection,
    };
};

export default useSimpleSort;
